export enum LinkRelation {
    STYLESHEET = "stylesheet",
    ICON = "icon",
    PRELOAD = "preload",
    PREFETCH = "prefetch",
    CANONICAL = "canonical",
    PREV = "prev",
    NEXT = "next",
}
